// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"async-node_modules_diff_lib_index_mjs":"c355743ff57ca2b7e120","common":"7a558c7723b9fb5563e1","js_pages_job_submit_js":"07fbaf00ca8a1f2a9d99"}[chunkId] + ".js";
};